import React from 'react';

export default function Flow({ step, children }) {
  const map = Object.create(null);
  React.Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) return;
    const name = child.props.name;
    if (name) map[name] = child;
  });
  return map[step] ?? null;
}

function Step({ children }) {
  return children;
}

Flow.Step = Step;
